import { Plus, X } from 'lucide-react';
import { Input } from './Input';

interface DynamicTextFieldsProps {
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function DynamicTextFields({
  values,
  onChange,
  placeholder = '',
  disabled = false,
}: DynamicTextFieldsProps) {
  const handleAdd = () => {
    onChange([...values, '']);
  };

  const handleRemove = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  const handleChange = (index: number, value: string) => {
    const newValues = [...values];
    newValues[index] = value;
    onChange(newValues);
  };

  // Always show at least one empty field
  const displayValues = values.length > 0 ? values : [''];

  return (
    <div className="space-y-2">
      {displayValues.map((value, index) => (
        <div key={index} className="flex items-center gap-2">
          <div className="flex-1">
            <Input
              value={value}
              onChange={(e) => handleChange(index, e.target.value)}
              placeholder={placeholder}
              disabled={disabled}
            />
          </div>
          {displayValues.length > 1 && (
            <button
              type="button"
              onClick={() => handleRemove(index)}
              disabled={disabled}
              className="text-ds-muted hover:text-ds-text disabled:cursor-not-allowed disabled:opacity-50"
              title="Fjern"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={handleAdd}
        disabled={disabled}
        className="flex items-center gap-1 text-sm text-ds-muted hover:text-ds-text disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Plus className="h-4 w-4" />
        <span>Tilføj</span>
      </button>
    </div>
  );
}
